import { IEnv } from "./env.type";

const hostname = location.hostname;

const parts = hostname.split(".");

const DOMAIN = "." + parts.slice(-2).join(".");

const devConfig = {
  API_URL: "https://apitest.daokey.ai",
  ECHO_HOST: "https://echotest.daokey.ai",
  BACKSTAGE_URL: "https://admintest.daokey.ai",
  DOMAIN,
  APP_SCHEME: "newlmsapp://open?",
  APP_ANDROID_INSTALL_PAGE_URL: "https://app.sjfood.us/#/DAOKEY-Test",
  APP_IOS_INSTALL_PAGE_URL: "https://apps.apple.com/us/app/daokey/id6471388310",
  OME_URL: "https://ome-account.wiltechs.com",
  VITE_APP_PKCE_APP_ID: "1eb0c53f-0daf-4ec9-ad76-20dd4ef1d9ce",
  VITE_APP_PKCE_SCOPES: "flexivid openid email phone offline_access createdway",
  WEB_URL: "https://test.daokey.ai",
};

const testConfig = {
  API_URL: "https://apitest.daokey.ai",
  ECHO_HOST: "https://echotest.daokey.ai",
  BACKSTAGE_URL: "https://admintest.daokey.ai",
  DOMAIN,
  APP_SCHEME: "newlmsapp://open?",
  APP_ANDROID_INSTALL_PAGE_URL: "https://app.sjfood.us/#/DAOKEY-Test",
  APP_IOS_INSTALL_PAGE_URL: "https://apps.apple.com/us/app/daokey/id6471388310",
  OME_URL: "https://ome-account.wiltechs.com",
  VITE_APP_PKCE_APP_ID: "1eb0c53f-0daf-4ec9-ad76-20dd4ef1d9ce",
  VITE_APP_PKCE_SCOPES: "flexivid openid email phone offline_access createdway",
  WEB_URL: "https://test.daokey.ai",
};

const prdConfig = {
  API_URL: "https://api.daokey.ai",
  ECHO_HOST: "https://echo.daokey.ai",
  BACKSTAGE_URL: "https://admin.daokey.ai",
  DOMAIN,
  APP_SCHEME: "newlmsapp://open?",
  APP_ANDROID_INSTALL_PAGE_URL: "https://app.sjfood.us/#/DAOKEY",
  APP_IOS_INSTALL_PAGE_URL: "https://apps.apple.com/us/app/daokey/id6471388310",
  OME_URL: "https://ome-account.omenow.com",
  VITE_APP_PKCE_APP_ID: "9e3a9c1d-6b53-4fb0-b66d-62c1399d731a",
  VITE_APP_PKCE_SCOPES: "flexivid openid email phone offline_access createdway",
  WEB_URL: "https://www.daokey.ai",
};

const getEnvConfig = (environment: string) => {
  if (environment === "test") {
    return testConfig;
  }
  if (environment === "prd") {
    return prdConfig;
  }

  return devConfig;
};

export const Env: IEnv = getEnvConfig((window as any).environment);
